<template>
  <div>
    <div :class="['fixed-filter', { active: value }]">
      <div class="d-flex align-center justify-space-between">
        <v-card-title class="pl-0">{{ $t("filter") }}</v-card-title>
        <v-btn icon @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <div class="select_on_block">
        <custom-input-text
          v-model="filter.orderNumb"
          @input="onChangeHandler"
          clearable
          :label="$t('numberRequest')"
          name="select_on_block"
        ></custom-input-text>
      </div>
      <div class="select_on_block">
        <custom-input-text
          v-model="filter.contractNumb"
          @input="onChangeHandler"
          clearable
          :label="$t('contractNumber')"
          name="select_on_block"
        ></custom-input-text>
      </div>
      <div class="select_on_block">
        <vue-select
          :get-item-promise="(name) => $store.dispatch('getProducts', { name })"
          @founded="(data) => $emit('update:products', data.data)"
          :items="products"
          v-model="filter.productId"
          @input="onChangeHandler"
          clearable
          custom-item
          :label="$t('product')"
          name="select_on_block"
        >
          <template #item="{ item, searchText }">
            <product-select-item
              :attrs="item.attrs"
              :name="item.name"
              :search-text="searchText"
            />
          </template>
        </vue-select>
      </div>
      <div class="pt-8">
        <v-btn
          @click="clearFilterHandler"
          color="#0382CE"
          dark
          max-height="37px"
          min-height="37px"
          class="btn_from"
        >
          <v-icon class="mr-6">mdi-trash-can-outline</v-icon>
          {{ $t("clear") }}
        </v-btn>
      </div>
    </div>
    <div
      class="global-backdrop"
      v-show="value"
      @click="$emit('input', false)"
    ></div>
  </div>
</template>

<script>
import { debounce } from "@/utils/pureFunctions";
import ProductSelectItem from "@/components/product/SelectItem";
import VueSelect from "@/components/ui/vue-select/VueSelect";

export default {
  name: "TeamIndexFilter",
  components: { VueSelect, ProductSelectItem },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    delay: {
      type: Number,
      default: 300,
    },
    filter: {
      type: Object,
    },
  },
  data() {
    return {
      onChangeHandler: null,
      loadingColumnInput: false,
      products: [],
    };
  },
  computed: {},
  methods: {
    clearFilterHandler() {
      this.$emit("update:filter", {
        requestNumber: null,
        contractNumb: null,
        fromDate: null,
        groupId: null,
        name: null,
        positionState: null,
        productNumber: null,
        requestState: null,
        sortBy: null,
        sortDirection: true,
        toDate: null,
        typeId: null,
        productName: null,
      });
      this.$nextTick(() => {
        this.$emit("change", this.filter);
      });
    },
  },
  mounted() {
    this.onChangeHandler = debounce(
      function () {
        this.$emit("change", this.filter);
      }.bind(this),
      this.delay
    );
  },
};
</script>
